import React, { Component } from "react";
import * as d3 from "d3";
import moment from "moment";
import ReactDOM from "react-dom";
import "./linechart.css";
import _ from "lodash";
import { dateFormat } from "../../../../constants/constants";
import {
  select,
  scaleLinear,
  scaleTime,
  axisBottom,
  axisLeft,
  line,
  pointer,
} from "d3";

let margin = {
  top: 10,
  right: 20,
  bottom: 25,
  left: 30,
};

const colors = [["#e74c3c", "#34495e"], "#3498db", "#9b59b6", "#2ecc71"];

function mkPoints(name, color, salt) {
  const count = 10;
  let now = moment().valueOf();
  if (salt === undefined) salt = parseInt(Math.random() * 10) * 86400000;
  now -= salt;
  return {
    name,
    color,
    points: [...Array(count).keys()].map((f) => {
      return {
        date: now - (count - f) * 86400000,
        value: parseInt(Math.random() * 100),
      };
    }),
  };
}

export function genData(prevData = []) {
  let salt = parseInt(Math.random() * 10) * 86400000;
  return {
    title: "Ictus",
    items: [
      mkPoints("foo", colors[0][0], salt),
      mkPoints("bar", colors[0][1], salt),
    ],
  };
}

function getXAxis(scale) {
  return d3.axisBottom(scale).ticks(5);
}

function getYAxis(scale) {
  return d3.axisLeft(scale).ticks(5);
}

function getYGrid(scale, width) {
  return d3.axisLeft(scale).ticks(5).tickSize(-width).tickFormat("");
}

export function initGraph(container, data) {
  let svg = d3.select(container).select("svg");
  let rect = container.getBoundingClientRect();
  let height = rect.height - margin.top - margin.bottom;
  let width = rect.width - margin.left - margin.right;

  let defs = svg.append("defs");
  defs.append("linearGradient").attr("id", "grd-x");

  let g = svg
    .append("g")
    .attr("class", "con")
    .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

  let yScale = d3.scaleLinear().range([height, 0]);
  let xScale = d3.scaleTime().range([0, width]);

  g.append("g")
    .attr("class", "x axis")
    .attr("transform", "translate(0, " + height + ")")
    .call(getXAxis(xScale));

  g.append("g").attr("class", "y axis").call(getYAxis(yScale));

  g.append("g").attr("class", "y grid").call(getYGrid(yScale, width));

  let paths = g.append("g").attr("class", "paths");

  paths.append("g").attr("class", "lines");

  paths.append("g").attr("class", "areas");

  // paths.append('path')
  //     .attr('class', 'area')
  //     .attr('fill', 'url(#' + data.title + '-ugx)');
  g.append("text")
    .attr("class", "lgdtxt")
    .attr("font-size", 12)
    .attr("fill", "#555")
    .attr("x", width - 115)
    .style("font-weight", "bold")
    .style("user-select", "none")
    .attr("y", 15);

  g.append("text")
    .attr("class", "valtxt")
    .attr("font-size", 12)
    .attr("fill", "#555")
    .attr("x", width - 200)
    .style("font-weight", "bold")
    .style("user-select", "none")
    .attr("y", 15);

  g.append("rect")
    .attr("class", "plcd")
    .attr("width", width)
    .attr("height", height)
    .attr("fill", "transparent");

  g.append("g").attr("class", "points");
}

export function updateData(container, data, props) {
  if (data && data.items.length && data.items[0].points.length)
    updateGraph(container, data, props);
  else setNoData(container, "No data");
}

function setNoData(container) {
  container.querySelector("g.grid.y").style.display = "none";
  container.querySelector("g.paths").style.display = "none";
  let p = container.querySelector(".gem");
  if (!p) {
    p = document.createElement("div");
    p.className = "gem";
    let g = document.createElement("div");
    g.innerText = "No data";
    p.appendChild(g);
    container.appendChild(p);
  } else p.style.display = "";
}

function removeEm(container) {
  let el = container.querySelector(".gem");
  if (el) el.style.display = "none";
}

function drawLine(svg, xScale, yScale, items) {
  let traces = svg.select("g.lines").selectAll("g.trace").data(items);
  traces
    .enter()
    .append("g")
    .attr("class", "trace")
    .merge(traces)
    .each(function (d, i) {
      let line = d3
        .line()
        .x((f) => xScale(f[d.key]))
        .y((d) => yScale(d.value));
      getCurve(line);
      let path = d3.select(this).selectAll("path.stk").data([0]);
      path
        .enter()
        .append("path")
        .attr("class", "stk")
        .merge(path)
        .attr("stroke", () =>
          Array.isArray(d.color)
            ? "url(#" + ["grd", i].join("-") + ")"
            : d.color
        )
        .attr("stroke-width", 2)
        .transition()
        .attr("d", line(d.points));
      path.exit().remove();
    });
  traces.exit().remove();

  for (let i in items) {
    let item = items[i];
    if (Array.isArray(item.color)) {
      for (let j in item.color) {
        let color = item.color[j];
        color.index = j;
      }
    }
  }
  let grads = svg.select("defs").selectAll("linearGradient").data(items);
  grads
    .enter()
    .append("linearGradient")
    .attr("x2", "100%")
    .merge(grads)
    .attr("id", (d, i) => "grd-" + i)
    .each(function (d) {
      d3.select(this).selectAll("stop").remove();
      for (let i in d.color) {
        let g = d.color[i];
        d3.select(this)
          .append("stop")
          .attr("offset", g.from + "%")
          .style("stop-color", g.color);
        d3.select(this)
          .append("stop")
          .attr("offset", g.to + "%")
          .style("stop-color", g.color);
      }
    });
}

function drawPoints(svg, xScale, yScale, data) {
  let traces = svg.select("g.points").selectAll("g.point").data(data.items);
  let pg = traces.enter().append("g").attr("class", "point").merge(traces);
  let dots = pg.selectAll("circle.color").data((d) => d.dots);
  dots
    .enter()
    .append("circle")
    .attr("class", "color")
    .attr("fill", (d) => d.color)
    .attr("stroke", (d) => d.stroke)
    .attr("r", 8)
    .merge(dots)
    .attr("cy", (d) => yScale(d.value))
    .attr("cx", (d) => xScale(d.time));
  dots.exit().remove();
  dots = pg.selectAll("circle.mouse").data((d) => d.dots);
  dots
    .enter()
    .append("circle")
    .attr("class", "mouse")
    .attr("fill", "transparent")
    .attr("r", 15)
    .merge(dots)
    .attr("cy", (d) => yScale(d.value))
    .attr("cx", (d) => xScale(d.time))
    .on("mouseenter", (d) => {
      highLightItem(svg._groups[0][0].closest(".afbll"), { xScale, yScale }, d);
      if (window.highLightTabItem) window.highLightTabItem(d);
    })
    .on("mouseleave", () => {
      highLightItem(svg._groups[0][0].closest(".afbll"), { xScale, yScale });
      if (window.highLightTabItem) window.highLightTabItem();
    });
  dots.exit().remove();
  pg.exit().remove();
  traces.exit().remove();
}

function highLightItem(p, axes, d) {
  let { xScale, yScale } = axes;
  if (d) {
    let el = document.createElement("div");
    el.className = "ttx";
    el.innerHTML = d.lbl;
    el.style.left = xScale(d.time) + 50 + "px";
    el.style.top = yScale(d.value) + "px";
    p.appendChild(el);
  } else {
    p.querySelector(".ttx").remove();
  }
}

function getCurve(item) {
  // item.curve(d3.curveMonotoneX);
  item.curve(d3.curveBasis);
}

function drawArea(svg, height, xScale, yScale, data) {
  let ac = svg.select("g.areas");
  let areas = ac.selectAll("g.area").data(data.items);
  areas
    .enter()
    .append("g")
    .attr("class", "area")
    .merge(areas)
    .each(function (d, i) {
      let area = d3
        .area()
        .x((f) => xScale(f[d.key]))
        .y0(height)
        .y1((d) => yScale(d.value));
      getCurve(area);
      let path = d3.select(this).selectAll("path.rtk").data([0]);
      path
        .enter()
        .append("path")
        .attr("class", "rtk")
        .attr("fill", "url(#" + d.name + "-ugx)")
        .merge(path)
        .transition()
        .attr("d", area(d.points));
      path.exit().remove();
    });
  areas.exit().remove();
  let defs = svg.select("defs");
  let grads = defs.selectAll("linearGradient.ugx").data(data.items);
  grads
    .enter()
    .append("linearGradient")
    .attr("class", "ugx")
    .attr("x1", "0%")
    .attr("x2", "0%")
    .attr("y1", "0%")
    .attr("y2", "100%")
    .attr("id", (d) => d.name + "-ugx")
    .each(function (d) {
      d3.select(this)
        .append("stop")
        .attr("offset", "5%")
        .attr("stop-opacity", 0.1);
      d3.select(this)
        .append("stop")
        .attr("offset", "95%")
        .attr("stop-opacity", 0);
    })
    .merge(grads)
    .each(function (d) {
      let stops = d3.select(this).selectAll("stop");
      d3.select(stops._groups[0][0]).attr("stop-color", d.color);
      d3.select(stops._groups[0][1]).attr("stop-color", d.color);
    });
}

function updateGraph(container, data, props) {
  container.querySelector("g.grid.y").style.display = "";
  container.querySelector("g.paths").style.display = "";
  removeEm(container);
  let items = data.items;
  let { xScale, yScale, height, width } = getAxes(container, items);
  let svg = d3.select(container).select("svg");
  svg
    .select("g.axis.x")
    .attr("transform", "translate(0, " + height + ")")
    .transition()
    .call(getXAxis(xScale));
  svg.select("g.axis.y").transition().call(getYAxis(yScale));
  svg.select("g.grid.y").transition().call(getYGrid(yScale, width));
  drawLine(svg, xScale, yScale, items);
  drawPoints(svg, xScale, yScale, data);
  /* legends */
  let pdata = items[0].points;
  let bisect = d3.bisector((d) => d.time).left;
  svg
    .select("g.con")
    .on("mousemove", function () {
      const coords = pointer(event, this);
      let x0 = xScale.invert(coords[0]);
      let di = bisect(pdata, x0, 1);
      let d0 = pdata[di - 1];
      let d1 = pdata[di];
      if (d0 && d1) {
        let p = d0.time - x0 > x0 - d1.time ? d0 : d1;
        svg.select("text.lgdtxt").text(moment(p.time).format(dateFormat));
        svg.select("text.valtxt").text("Fuel: " + p.value);
      }
      if (props.changeTime) props.changeTime(x0);
    })
    .on("mouseleave", function () {
      svg.select("text.lgdtxt").text("");
      svg.select("text.valtxt").text("");
    });
  // drawArea(svg, height, xScale, yScale, data);
}

function getAxes(container, items) {
  let height = container.offsetHeight - margin.top - margin.bottom;
  let width = container.offsetWidth - margin.left - margin.right;
  let values = items
    .map((d) => d.points.map((d) => d.value))
    .reduce((a, b) => a.concat(b), []);
  let dates = items
    .map((f) => f.points.map((d) => d[f.key]))
    .reduce((a, b) => a.concat(b), []);
  let maxY = Math.max(...values);
  return {
    yScale: d3
      .scaleLinear()
      .range([height, 0])
      .domain([0, maxY * 1.3]),
    xScale: d3.scaleTime().range([0, width]).domain(d3.extent(dates)),
    height,
    width,
  };
}

class LineChart extends Component {
  data = { items: [] };
  componentDidMount() {
    let el = ReactDOM.findDOMNode(this);
    initGraph(el);
    document.addEventListener("visibilitychange", this.visibilityChange);
  }
  setData = (data) => {
    this.data = data;
    let el = ReactDOM.findDOMNode(this);
    let action = () => updateData(el, data, this.props);
    if (document.visibilityState === "visible") action();
    else this.onVisible = action;
  };
  highLightItem = (d) => {
    let el = ReactDOM.findDOMNode(this);
    let axes = getAxes(el, this.data.items);
    highLightItem(el, axes, d);
  };
  redraw = () => {
    updateData(ReactDOM.findDOMNode(this));
  };
  visibilityChange = () => {
    if (this.onVisible && document.visibilityState === "visible") {
      this.onVisible();
      delete this.onVisible;
    }
  };
  render() {
    return (
      <div className="afbll">
        <svg></svg>
      </div>
    );
  }
}

export default LineChart;
